import {NgModule} from '@angular/core';

import {ApplicationSubheaderDirective} from './application-subheader.directive';

@NgModule({
  declarations: [ApplicationSubheaderDirective],
  exports: [ApplicationSubheaderDirective],
})
export class ApplicationSubheaderModule {}
